import { Component } from 'preact'

import Editor from './index.js'

export default class extends Component {
  constructor () {
    super()
    this.state = {
      attachments: [],
      content: ''
    }
  }
  render (props) {
    return <div>
      <Editor {...props}
        isControl={false}
        onChange={(content, attachments) => this.setState({ content, attachments })}
      />
      <input type='hidden' name={props.contentInputName} value={this.state.content} />

      {this.state.attachments.map(
        attachment => <input type='hidden' name={props.attachmentsInputName} value={JSON.stringify(attachment)} />
      )}

    </div>
  }
}
